export default "__VITE_ASSET__CwhkQjbK__"